jQuery(document).ready(function ($) {

    /**
     * SlickSlider init
     *
     * Do NOT edit here, overwrite Slick Slider in Theme js
     * Destroy with unslick(), init with slick()
     *
     * http://kenwheeler.github.io/slick/
     *
     * */

    try {

        $('.wp-block-custom-blocks-slider').slick({
            autoplay: false,
            dots: true,
            arrows: true,
            infinite: true,
            speed: 1000,
            centerMode: false,
            variableWidth: false,
            mobileFirst: true
        });

        $(window).on('resize orientationchange', function () {
            $('.wp-block-custom-blocks-slider.slick-initialized').slick('resize');
        });

    } catch(err){}

});



// WEBPACK FOOTER //
// ./src/blocks/slider/js/script.js